// @flow

import * as React from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import { useLocale } from '../../../hooks/locale';
import { useViewportType } from '../../../hooks/viewport-type';
import { type Descriptor, createDescriptor } from '../../../controls/router';
import {
  type ShowMapParams,
  showMapDescriptor,
  type MapBoundsParams,
  mapBoundsDescriptor,
} from './sharedDescriptors';

export const descriptor: Descriptor<{|
  ...ShowMapParams,
  ...MapBoundsParams,
|}> = createDescriptor(mapBoundsDescriptor, showMapDescriptor);

export const MapSwitch = (): React.Node => {
  let [{ showMap }, set, flush] = descriptor.useState();
  const viewportType = useViewportType();
  showMap = showMap ?? viewportType === 'desktop';

  const { t } = useLocale();

  return (
    <FormControlLabel
      css={{
        marginRight: 0,
        '.MuiFormControlLabel-label': {
          marginRight: 10,
        },
      }}
      labelPlacement="start"
      label={t('showMap')}
      control={
        <Switch
          color="primary"
          checked={showMap}
          onChange={e => {
            const showMap = e.target.checked;
            set({
              showMap,
              ...(showMap
                ? {}
                : { west: null, south: null, north: null, east: null }),
            });
            flush();
          }}
        />
      }
    />
  );
};
